import React, { useState } from "react";
import "../assets/styles/Contact.css";

const WHATSAPP_NUMBER = "918830308668"; // primary contact

function Contact() {
  const [form, setForm] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const handleChange = (e) => {
    setForm((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const text =
      `*New Enquiry — Sunleaf Villa*\n\n` +
      `*Name:* ${form.name}\n` +
      `*Email:* ${form.email}\n` +
      `*Phone:* ${form.phone}\n` +
      `*Message:* ${form.message}`;

    const url = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(text)}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  return (
    <>
      <section id="contact" className="contact-section">
        {/* LEFT — Contact Details */}
        <div className="contact-info">
          <h2 className="contact-heading">Get in Touch</h2>

          <p className="contact-description">
            Experience comfort, luxury and peaceful living at Sunleaf Villa.
            Contact us for bookings, enquiries or private visits.
          </p>

          <div className="contact-item">
            <span>Omkar Nimbalkar</span>
            <p>+91 8830 308668</p>
          </div>

          <div className="contact-item">
            <span>Pratik Pawar</span>
            <p>+91 88066 31372</p>
          </div>

          <div className="contact-item">
            <span>Email</span>
            <p>sunleafpalace@gmail.com</p>
          </div>

          <div className="contact-item">
            <span>Website</span>
            <p>www.sunleafvilla.com</p>
          </div>

          <div className="contact-item">
            <span>Address</span>
            <p>
              Sunleaf Palace, Ram Indu Park, Lane No.01 <br />
              Opposite Mithila Residency, Baner <br />
              Pune, Maharashtra 411045
            </p>
          </div>
        </div>

        {/* RIGHT — Form */}
        <div className="contact-form-area">
          <h2 className="contact-heading">Send Us a Message</h2>

          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="floating-group">
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                required
                placeholder=" "
              />
              <label>Full Name</label>
            </div>

            <div className="floating-group">
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                required
                placeholder=" "
              />
              <label>Email Address</label>
            </div>

            <div className="floating-group">
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                required
                placeholder=" "
              />
              <label>Phone Number</label>
            </div>

            <div className="floating-group">
              <textarea
                name="message"
                rows="4"
                value={form.message}
                onChange={handleChange}
                required
                placeholder=" "
              ></textarea>
              <label>Your Message</label>
            </div>

            <button type="submit" className="contact-btn">
              <i className="fab fa-whatsapp" aria-hidden="true"></i>
              Send via WhatsApp
            </button>
          </form>
        </div>
      </section>

      {/* Google Map */}
      <div className="contact-map">
        <iframe
          title="Sunleaf Villa Location"
          src="https://www.google.com/maps?q=Sunleaf%20Palace%20Baner%20Pune&output=embed"
          loading="lazy"
        ></iframe>
      </div>
    </>
  );
}

export default Contact;
